<template>
  <div>
    <div style="display:flex;">
      <div>
        <b-avatar variant="primary" />
      </div>
      <div class="providerName ml-2">{{ provider.providerName }}<br /></div>
    </div>

    <div
      v-for="(a, index) in groupBy(provider.schedule, 'procedureArray')"
      v-bind:key="index"
    >
      <div class="text-muted pt-2">
        <div class="pt-1">
          {{ (provider.minutes * 60 * 1000) | humanize }}
        </div>
        <div class="pt-2">
          {{ index }}
        </div>
        <div class="pt-2">
          <strong>{{ (provider.total / 100) | currency }}</strong>
        </div>
      </div>

      <hr class="p-0 mt-3 mb-0" />
      <div v-for="(b, i2) in groupBy(a, 'friendlyTimeOfDay')">
        <div class="timeOfDay ">{{ i2 }}</div>

        <div class="buttonWrapper">
          <div v-for="c in b">
            <div class=" mt-2">
              <div>
                <b-button
                  :class="getTimeButtonClass(c)"
                  style="width:120px"
                  @click="selectTime(c)"
                >
                  {{ c.startDate | moment("hh:mm a") }}
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { sliceEventStore } from "@fullcalendar/core";
export default {
  props: { provider: null, date: null },
  data() {
    return {
      times: [],
    };
  },
  watch: {
    date: {
      handler(newDt, oldDt) {
        // clear times on a date change
        this.times = [];
      },
    },
  },
  methods: {
    hasTime(c) {
      return this.times.find(
        (x) => x.startDate == c.startDate && x.endDate == c.endDate
      );
    },
    getTimeButtonClass(c) {
      var a = this.hasTime(c);
      if (a) return "btn btn-success shadow";
      else return "btn-outline-light  shadow-none";
    },
    selectTime(c, provider) {
      var hasTimeAlready = this.hasTime(c);

      if (hasTimeAlready && hasTimeAlready.startDate == c.startDate) {
        this.$emit("timeRemoved", this.provider.providerId);
        this.times = [];
        return;
      }

      this.times = [];

      this.times.push({
        startDate: c.startDate,
        endDate: c.endDate,
      });

      this.$emit("timeSelected", {
        provider: this.provider,
        timeFrame: c,
      });
    },
    groupBy(xs, key) {
      var s = xs.reduce(function(rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
      }, {});

      return s;
    },
  },
};
</script>

<style scoped>
.providerName {
  font-size: 1.1em;
  padding-top: 9px;
  padding-left: 5px;
  font-weight: bold;
}
.buttonWrapper {
  display: grid;
  grid-template-columns: repeat(auto-fit, 120px);
  column-gap: 5px;
}
.timeOfDay {
  padding-top: 10px;
  font-size: 1em;
  font-weight: bold;
  padding-bottom: 10px;
}
</style>
